import { useIntl } from "react-intl";
import { CompetitorTypes } from "~enums/competitorTypes";
import { useGetFixture } from "~pages/Fixtures/hooks";
import type { FixtureEntrantTransformed } from "~pages/Fixtures/types";

export const useFixtureName = () => {
  const { formatMessage } = useIntl();
  const { data: fixtureData, isLoading } = useGetFixture();

  if (isLoading || !fixtureData) {
    return undefined;
  }

  const isCompetitors = fixtureData.competitorType === CompetitorTypes.Entity;
  const isParticipants = fixtureData.competitorType === CompetitorTypes.Person;

  if (!isCompetitors && !isParticipants) {
    return formatMessage({ id: "pageTitles.advancedFixtureEdit.fixtureOnly" });
  }

  const entrants =
    fixtureData.competitorType === CompetitorTypes.Person ? fixtureData.formData.participants : fixtureData.formData.competitors;

  const notSpecifiedText = formatMessage({ id: "not.specified" });
  const getName = (sideEntrants: FixtureEntrantTransformed[]) => {
    const names = (sideEntrants || []).map((entrant) => entrant.name).filter(Boolean);
    return names.length > 0 ? names.join(" / ") : notSpecifiedText;
  };

  const homeName = getName(entrants.filter((entrant) => entrant.isHome));
  const awayName = getName(entrants.filter((entrant) => !entrant.isHome));

  return formatMessage({ id: "pageTitles.advancedFixtureEdit" }, { homeName, awayName });
};
